/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/
import React from 'react';

import FormContainer from 'components/FormContainer';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';

function RenderSection({
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire
}) {
  return (
    <FormContainer show={true} title="Entity Information">
      <FormSection
        sectionName="ENTITY_INFO"
        errors={formikProps.errors}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        values={formikProps.values}
        setFieldValue={formikProps.setFieldValue}
        setFieldError={formikProps.setFieldError}
        formikRef={formikRef}
        idProduct={idProduct}
      />
    </FormContainer>
  )
}

const components = {
  RenderSection
};

export { components };